// angular
//     .module("HeroPRO")
//     .directive("hpHint", hpHint);

export default function hpHint() {
    return {
        templateUrl: 'app/common/hints/hints.html',
        controller: 'hintsController',
        controllerAs: 'hint',
        bindToController: true,
        scope: {
            id: '@',
            copy: '@',
        },
        restrict: 'E',
    };
}



// WEBPACK FOOTER //
// ./src/app/common/hints/hintsDirective.js